import { Button, Spin } from "antd";
import LabeledInput from "components/Form/LabeledInput";
import LabeledSelectInput from "components/Form/LabeledSelectInput";
import WindIcon from "components/Icons/WindIcon";
import useEditDriverWallet from "hooks/driverWallets/useEditDriverWallet";

export default function EditDriverWallet() {
  const {
    control,
    handleSubmit,
    loading: { button, page },
    onSubmit,
  } = useEditDriverWallet();

  return (
    <div
      className="w-full bg-white rounded-lg p-6"
      style={{ boxShadow: "0 4px 25px 0 rgba(0,0,0,.1)" }}
    >
      <div className="w-full pt-5 pb-5">
        <div className="w-full">
          <h1 className="p-5 font-light text-lg text-center">
            Edit Driver Wallet
          </h1>
          <div className="w-full">
            <div className="w-full relative h-1 top-7 overflow-clip rounded-md">
              <div className="w-1/2 bg-black h-full rounded-md"></div>
            </div>
            <div className="relative w-full flex justify-center">
              <div className="relative h-14 w-14 bg-black rounded-full flex items-center justify-center text-white text-2xl">
                <WindIcon />
              </div>
            </div>
          </div>
          <p className="text-center mt-2 text-sm font-normal">
            Wallet Information
          </p>
        </div>
        <div className="w-full py-8 px-5">
          {page ? (
            <div className="w-full flex items-center justify-center py-20">
              <Spin />
            </div>
          ) : (
            <form
              onSubmit={handleSubmit(onSubmit)}
              className="w-full flex flex-wrap"
            >
              <div className="w-full px-4 pt-5 md:w-1/3">
                <LabeledSelectInput
                  label="Bank"
                  control={control}
                  name="bank"
                  placeholder="Select Bank"
                  options={[
                    { name: "Abay Bank" },
                    { name: "Enat Bank" },
                    { name: "Hijra Bank" },
                    { name: "Nib International Bank" },
                    { name: "Oromia International Bank" },
                    { name: "Sinqee Bank" },
                    { name: "United Bank" },
                    { name: "Wegagen Bank" },
                    { name: "ZamZam Bank" },
                    { name: "Zemen Bank" },
                    { name: "Global Bank" },
                    { name: "Amhara Bank" },
                    { name: "Ahadu Bank" },
                    { name: "Awash International Bank" },
                    { name: "Addis International Bank" },
                    { name: "Bank of Abyssinia" },
                    { name: "Berhan International Bank" },
                    { name: "Bunna Bank" },
                    { name: "Commercial Bank Of Ethiopia" },
                    { name: "Cooperative Bank of Oromia" },
                    { name: "Lion International Bank" },
                    { name: "Dashen Bank" },
                    { name: "Rays MFI" },
                    { name: "Somali Micro Finance" },
                    { name: "KAAFI MFI" },
                    { name: "telebirr - wallet" },
                    { name: "CBE Birr" },
                    { name: "Sahal mfi" },
                    { name: "Tsehay bank" },
                    { name: "Yaya wallet" },
                  ].map((value) => ({
                    value: value.name,
                    label: value.name,
                  }))}
                />
              </div>
              <div className="w-full px-4 pt-5 md:w-1/3">
                <LabeledInput
                  label="Account Number"
                  type="text"
                  control={control}
                  name="account"
                  placeholder="Account Number"
                />
              </div>
              <div className="w-full px-4 pt-5 md:w-1/3">
                <LabeledInput
                  disabled
                  label="Wallet balance"
                  type="number"
                  control={control}
                  name="balance"
                  placeholder="Wallet balance"
                />
              </div>
              <div className="w-full flex mt-8 justify-end">
                <Button
                  loading={button}
                  htmlType="submit"
                  type="primary"
                  className="py-2 px-8 rounded-md float-right h-auto font-medium w-fit shadow-none"
                >
                  Update Wallet
                </Button>
              </div>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
